export default "__VITE_ASSET__0a871f21__"